import * as firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

const app = firebase.initializeApp({
  apiKey: 'AIzaSyAsOk4JDydQyPsEUxTFDzRZL7ktp_Dhgek',
  authDomain: 'dataplatform-3334d.firebaseapp.com',
  databaseURL: 'https://dataplatform-3334d.firebaseio.com',
  projectId: 'dataplatform-3334d',
  storageBucket: 'dataplatform-3334d.appspot.com',
  messagingSenderId: '726120980021',
  appId: '1:726120980021:web:fa420ba1f4b94dcd',
});

export const auth = app.auth();
export const db = app.database();
